/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ILianxinMenuData } from './lianxin-menu.data';
import { ILianxinMenuProps } from './lianxin-menu.props.autogenerated';

export interface ILianxinMenuViewProps extends ILianxinMenuProps<ILianxinMenuData> {}

/**
 *
 * LianxinMenu component
 * @extends {React.PureComponent<ILianxinMenuProps<ILianxinMenuData>>}
 */
class LianxinMenu extends React.PureComponent<ILianxinMenuProps<ILianxinMenuData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default LianxinMenu;
